import React, { Suspense, lazy } from 'react';

const HourlyForecastWrapper = lazy(() => import('./hourlyForecastWrapper'));

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const HourlyForecastWrapperLazy = () => {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <HourlyForecastWrapper />
        </Suspense>
    );
};
